import { classes, config } from './Constants';
import SwiperSlider from './SwiperSlider';
import ControlVideo from './controlVideo';

export default class ModBannerHome {
  constructor(el) {
    this.$el = $(el);
    this.classes = classes;
    this.config = config;
    this.dom = {
      $btnControl: this.$el.find(`.${this.classes.btnPlayPause}`),
      $btnControlSound: this.$el.find(`.${this.classes.btnControlSound}`),
    };

    window.listVideo = [];
    this.checkPlayVideo = false;
    this.positionFlag = 0;
    this.SwiperSlider = new SwiperSlider(el, this.dom.$btnControl, this.dom.$btnControlSound);
    this.ControlVideo = new ControlVideo(el, this.dom.$btnControl, this.dom.$btnControlSound);
    this.init();
  }

  init() {
    this.SwiperSlider.cloneBannerItemSlide();
    this.SwiperSlider.swiperSlider();
    this.SwiperSlider.keyBoardEvent();
    this.hoverBanner();
    this.hideOverylay();
    if (typeof this.onYouTubeIframeAPIReady === 'function') {
      this.ControlVideo.addListener();
      this.checkScroll();
      this.SwiperSlider.addListener();
    };
  }

  hideOverylay() {
    $(document).ready(() => {
      setTimeout(() => {
        // Make elements visible again
        const bannerItems = $('.mod-banner-home .swiper-slide.banner-item-hide');
        // Loop through each item and set visibility to "visible"
        bannerItems.each((_index, bi) => {
          bi.style.setProperty('visibility', 'visible');
        });
        // Make elements visible again - Salseforce disable these using the 'Flicker Defender' option.
        const bannerItemsSF = $('.mod-banner-home .swiper-slide.banner-item');
        // Loop through each item and set visibility to "visible"
        bannerItemsSF.each((_index, bi) => {
          bi.style.setProperty('visibility', 'visible');
        });
        // Hide the loading overlay
        $('#loading-overlay').hide(); // Replace '.your-element' with your selector
      }, 2250); // 2250 milliseconds = 2.25 seconds
    });
  }

  hoverBanner() {
    // hover banner home
    this.$el.on('mouseenter', () => {
      this.$el.addClass('hovering-banner');
    });
    // hover leave banner home
    this.$el.on('mouseleave', () => {
      this.$el.removeClass('hovering-banner');
    });
  }

  onYouTubeIframeAPIReady() {
    console.log('YouTube API is ready');
  };

  checkScroll() {
    window.scrollAgent.scrollEvent((args) => {
      const scrollY = parseFloat(args.scroll.y.toFixed(2));
      if (scrollY > 10 && this.positionFlag !== scrollY) {
        this.positionFlag = scrollY;
        if (scrollY > this.$el.innerHeight()) {
          window.listVideo.forEach((_elem, i) => {
            if (window.listVideo[i] !== '') {
              this.ControlVideo.handlePause(i);
              this.checkPlayVideo = false;
            }
          });
        } else {
          this.checkScrollSwiperActive();
        }
      }
    });
  }

  checkScrollSwiperActive () {
    const $statusItemActive = this.$el.find(`.${this.classes.bannerItem}.swiper-slide-active`);
    const $index = $statusItemActive.find(`.${this.classes.bannerBgVideo}`).attr(this.config.dataPlayer);
    if (!this.checkPlayVideo) {
      const index = Number($index) - 1;
      if ($(window).innerWidth() > 1199) {
        this.handleSound(index);
      }
      this.checkPlayVideo = true;
      if (!$statusItemActive.hasClass(this.classes.pauseVideo)) {
        this.ControlVideo.handlePlay(index);
      }
    }
  }

  handleSound(index) {
    if (window.mutedVideo === false) {
      this.ControlVideo.handleMute(index);
      this.dom.$btnControlSound.removeClass(this.classes.activeSound);
    } else {
      this.ControlVideo.handleUnMute(index);
      this.dom.$btnControlSound.addClass(this.classes.activeSound);
    }
  }

}
